import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { callLcosService } from "../../data/lcosServices";
import { useAccessToken } from "../use-access-token";

export interface SchoolLookupResult {
  schoolCode: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  schoolType: string;
}

export const MIN_SCHOOL_SEARCH_LENGTH = 3;

export const useFindSchools = (search?: string) => {
  const { getToken } = useAccessToken();
  const normalizedSearch = search?.trim() ?? "";

  const query = useQuery({
    queryKey: ["findSchools", normalizedSearch],
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: async () => findSchools(await getToken(), normalizedSearch!),
    enabled: normalizedSearch.length >= MIN_SCHOOL_SEARCH_LENGTH
  });

  const schools = useMemo(() => query.data?.schools ?? [], [query.data]);

  return {
    schools,
    isLoading: query.isLoading
  };
};

const findSchools = (accessToken: string, search: string) => {
  return callLcosService<{ schools: SchoolLookupResult[] }>(
    accessToken,
    `/api/schools?search=${encodeURIComponent(search)}`,
    "GET"
  );
};
